export default __webpack_public_path__ + "static/thebottomline1-c82e9522a9986c8b835547391dc26db0.jpg";